'use client';

import type { StoryblokReactComponent } from '@/storyblok/components/componentsMap';
import { FooterButtonStoryblok } from '@/storyblok/types';

export const FooterCookieButton: StoryblokReactComponent<FooterButtonStoryblok> = ({ component: link }) => {
  return (
    <button
      className="text-sm font-semibold transition-colors hover:text-text-body focus:text-text-body"
      onClick={() => {
        if (window.CookieConsent) {
          window.CookieConsent?.show();
        } else {
          window.alert('I Cookie non sono abilitati in questo browser');
        }
      }}
    >
      {link.title}
    </button>
  );
};
